import { ChevronRight, Home } from 'lucide-react'
import React from 'react'

export function Breadcrumbs({base, baseLink, currentNav}) {
  return (
    <nav className="flex" aria-label="Breadcrumb">
      <ol className="inline-flex items-center space-x-1 md:space-x-2 capitalize">
        <li className="inline-flex items-center">
          <a
            href={baseLink}
            className="ml-1 inline-flex items-center text-sm font-medium text-gray-800 hover:underline "
          >
            <Home className="mr-4 h-4 w-4" aria-hidden="true" />
            {base}
          </a>
        </li>
        {/* <li>
          <div className="flex items-center">
            <ChevronRight className="h-4 w-4" aria-hidden="true" />
            <a href="#" className="ml-1 text-sm font-medium text-amber-600 hover:underline md:ml-2">
              {currentNav}
            </a>
          </div>
        </li> */}
        <li aria-current="page">
          <div className="flex items-center">
            <ChevronRight className="h-4 w-4" />
            <span className="ml-1 text-sm font-medium text-amber-600">
              {currentNav}
            </span>
          </div>
        </li>
      </ol>
    </nav>
  )
}
